import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { clickStreamUser } from "../../utils/AppUtils";
import { useTranslation } from "react-i18next";

const BackButton = () => {
  const navigate = useNavigate();
  const authBroker = useSelector((state) => state.auth.authBroker);
  const { t } = useTranslation();
  return (
    <div className="col-md-12 mb-4 d-flex justify-content-start">
      <button
        className="btn btn-primary-complete bckbtn m-0"
        onClick={() => {
          clickStreamUser(
            "back-btn",
            {
              userId: authBroker?.payload?.user.user_id,
            },
            authBroker,
          );
          navigate(-1);
        }}
      >
        {t("back")}
      </button>
    </div>
  );
};

export default BackButton;
